import { DYNAMIC_REWARDS_TAB_CONTENT_VIEW } from './types';

export const triggerDynamicRewardsTabContentIsViewed = activeTabLink => ({
  type: DYNAMIC_REWARDS_TAB_CONTENT_VIEW,
  activeTabLink,
});
